module.exports = __webpack_public_path__ + "static/nutrition_root_layout-facb1fc56f865286997f9100bc0a66d2.png";